import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

export function trackFeedbackOpen(stepNumber) {
    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
        data: { pageName: `${anaConsts.SUPER_CHAT.SUPERCHAT_FEEDBACK} ${stepNumber}:*` } // prop55
    });
}

export function trackFeedbackSubmit(stepNumber) {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            //prop55
            actionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_FEEDBACK_SUBMITTED,
            pageName: `${anaConsts.SUPER_CHAT.SUPERCHAT_FEEDBACK} ${stepNumber}:*`
        }
    });
}
